module.exports = __webpack_public_path__ + "img/delivery-truck-error.a223f667.svg";